export const GET_FLAT_DOCUMENTS = "GET_FLAT_DOCUMENTS"
export const CREATE_FLAT_DOCUMENTS = "CREATE_FLAT_DOCUMENTS"
export const UPDATE_FLAT_DOCUMENTS = "UPDATE_FLAT_DOCUMENTS"
export const REMOVE_FLAT_DOCUMENTS = "REMOVE_FLAT_DOCUMENTS"
